export enum Breakpoints {
    Mobile = 430,
    Tablet = 1024,
}
